import { ReactElement } from 'react'
import { ListItem } from '../interfaces'
import { FilterGroupSearchDropdown } from './FilterGroupSearchDropdown'
import { FilterOptionList } from './FilterOptionList'

interface CheckboxFilterGroupProps {
  groupName: string
  options: ListItem[]
  onChange: (filterName: string, selectedOptions: ListItem[]) => void
}

export const CheckboxFilterGroup = ({
  groupName,
  options,
  onChange,
}: CheckboxFilterGroupProps): ReactElement => {
  const searchInputId = `${groupName.toLowerCase().replace(/\s+/g, '-')}-search`

  return (
    <>
      <FilterGroupSearchDropdown
        inputId={searchInputId}
        groupName={groupName}
        options={options}
        onChange={onChange}
      />
      <FilterOptionList
        groupName={groupName}
        options={options}
        onChange={onChange}
      />
    </>
  )
}
